import React, { ReactNode, useEffect, useRef, useState } from 'react';
import { toRem } from 'design';

interface InfiniteScrollProps {
  id?: string;
  children: ReactNode;
  fetchMore: () => Promise<void>;
  earlyFetch?: boolean;
}

const InfiniteScroll: React.FC<InfiniteScrollProps> = ({ id = 'sentinel', children, fetchMore, earlyFetch }) => {
  const [isFetching, setIsFetching] = useState(false);
  const observer = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
    const options = {
      rootMargin: '0px',
      threshold: 1.0,
    };

    observer.current = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !isFetching) {
          setIsFetching(true);
          fetchMore().then(() => {
            setIsFetching(false);
          });
        }
      });
    }, options);

    const sentinel = document.getElementById(id);
    if (observer.current && sentinel) {
      observer.current.observe(sentinel);
    }

    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, [fetchMore, isFetching]);

  return (
    <>
      {children}
      <div id={id} style={{ height: toRem(10), ...(earlyFetch && { position: 'relative', bottom: toRem(250) }) }} />
    </>
  );
};

export default InfiniteScroll;
